/** question id to array [key - answer position, value - points to add] or universalScore stands for +1 point per each answer */
const debug = 0;
let nutritionScoreReferencer = {
    //How long does it take you to recover from intense exercise?
    '72iM9MO': {
        'reference': [1, 7, 13],
        'universalScore': null,
        'emptyAnswerScore': null
    },
    //Do you tend to suffer from muscle cramps after exercise?
    'ENiaXNR': {
        'reference': [13, 9, 5, 1],
        'universalScore': null,
        'emptyAnswerScore': null
    },
    //What about delayed onset muscle soreness (1-2 days post exercise)?
    'ZMiWAeW': {
        'reference': [13, 9, 5, 1],
        'universalScore': null,
        'emptyAnswerScore': null
    },
    //How many times do you get ill over the course of a year?
    'ENiRW02': {
        'reference': [1, 4, 7, 10, 13, 13],
        'universalScore': null,
        'emptyAnswerScore': null
    },
    //When you do get ill, how long does it take you to recover?
    'a2iLqNm': {
        'reference': [1, 7, 13],
        'universalScore': null,
        'emptyAnswerScore': null
    },
    //More often than not, do you suffer from any of the following?
    'ZMiRYdr': {
        'reference': [13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13],
        'universalScore': null,
        'emptyAnswerScore': 10
    },
    //Do you struggle with any of the following conditions?
    'GQin0OV': {
        'reference': [13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13],
        'universalScore': null,
        'emptyAnswerScore': 7
    },
    //Do you struggle getting to sleep?
    'YqiaZzR': {
        'reference': [13, 7, 1],
        'universalScore': null,
        'emptyAnswerScore': null
    },
    //On average, how many portions of fruit and veg do you eat per day?
    'gei70gQ': {
        'reference': [13, 9, 5, 1],
        'universalScore': null,
        'emptyAnswerScore': null
    },
    //On average how many portions of oily fish do you eat on a weekly basis?
    'x1iJgBj': {
        'reference': [13, 9, 5, 1],
        'universalScore': null,
        'emptyAnswerScore': null
    },
    //Do you get at least 30 minutes exposure to midday sun on a daily basis?
    '9Xilge0': {
        'reference': [13, 7, 1],
        'universalScore': null,
        'emptyAnswerScore': null
    },
}

function getIconsObj(productsDetails) {
    const bodyFuelObj = productsDetails.find(product => product.NAME.search('Fuel'))
    if (!bodyFuelObj) {
        return {};
    }
    return {
        'goal': bodyFuelObj.HEADER_ICONS.find(product => product.CATEGORY === 'Goal'),
        'dietaryNeeds': bodyFuelObj.HEADER_ICONS.find(product => product.CATEGORY === 'Dietary Needs'),
        'howToTake': bodyFuelObj.HEADER_ICONS.find(product => product.CATEGORY === 'How to Take'),
        'symptom': bodyFuelObj.HEADER_ICONS.find(product => product.CATEGORY === 'Symptom'),
        'weightDelta': bodyFuelObj.HEADER_ICONS.find(product => product.CATEGORY === 'Weight Delta'),
    }
}


function isSpecialCurrencySign(sign) {
    return ['€', '£', '$'].includes(sign)
}

function getCurrencySignFromCookie() {
    const currencySignsArray = {
        'BGN': 'лв',
        'CZK': 'Kč',
        'DKK': 'kr',
        'EUR': '€',
        'GBP': '£',
        'HUF': 'Ft',
        'PLN': 'zł',
        'RON': 'lei',
        'SEK': 'kr',
        'USD': '$',
    };
    let selectedCurrency = getCookie('cart_currency');
    if (!selectedCurrency) selectedCurrency = "GBP";
    return currencySignsArray[selectedCurrency] ?? '£'
}

function isCurrencyWithComma() {
    const selectedCurrency = getCookie('cart_currency');
    if (!['USD', 'EUR', 'GBP'].includes(selectedCurrency)) {
        return true
    }
    return false;
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

async function isUS() {
    const geoIPCheck = await fetch('/browsing_context_suggestions.json').then(response => response.json())
    console.log(geoIPCheck.detected_values.country.handle)
    if (geoIPCheck?.detected_values?.country?.handle === "US") {
        if (!document.URL.includes('en-us') && !document.URL.includes('127.0.0.1')) {
            window.location.replace(window.location.origin + '/en-us' + window.location.pathname);
        }
        return geoIPCheck.location.country === "US"
    }
    /* url can also be source of geo info */
    return (window.location.href.indexOf("en-us") > -1);
}

async function prqQuizCallback(quizRawResults) {
    const firstEvent = new MessageEvent('quiz-submitted');
    window.dispatchEvent(firstEvent);
    const loaderId = setTimeout(() => {
        console.log('time to restart a page')
        location.reload();
    }, 10000);
    const started = Date.now();
    quizRawResults.getQuestionDataById = function (questionId) {
        return this.quiz.attributes.slides.data.find(slide => slide.id === questionId)
    };
    console.log('quizRawResults', quizRawResults)

    // const usaGeo = (window.location.href.indexOf("en-us") > -1);
    const usaGeo = await isUS();
    console.log('usaGeo', usaGeo)
    let quizData = {
        'data': {
            'name': getOnlyFirstName(getRawAnswer('ENiRVjd', quizRawResults)),
            'email': getRawAnswer('GQinjbX', quizRawResults),
            'gender': getSelectSingeAnswerText('kdixBJz', quizRawResults),
            // 'gender': getSelectSingeAnswerText("GQin0RG", quizRawResults),
            'diet': getSelectSingeAnswerText('jxiVBMj', quizRawResults),
            'weight': getRawAnswer('qQieo7M', quizRawResults),
            'height': getRawAnswer('MLixQNj', quizRawResults),
            'targetWeight': getRawAnswer('laiQQ2D', quizRawResults),
            'targetBodyFat': getRawAnswer('x1iOldP', quizRawResults),
            'steps': getSelectSingeAnswerText('O9iG8z6', quizRawResults),
            'fish': getSelectSingeAnswerText('x1iJgBj', quizRawResults),
            'age': getAge('Wki0OEk', quizRawResults),
            'nutritionLevel': getNutritionLevel(quizRawResults),
            'symptoms': getMultipleSelectAnswersAsText('ZMiRYdr', quizRawResults),
            'fruitAndVeg': getSelectSingeAnswerText('gei70gQ', quizRawResults),
            'activities': getMultipleSelectAnswersAsText('gei7x2G', quizRawResults),
            'fitnessGoals': getMultipleSelectAnswersAsText('VZioekZ', quizRawResults),
            'recommendedProducts': getProducts(quizRawResults),
            usaGeo,
            currencySign: getCurrencySignFromCookie()
        }
    };

    getCurrencySignFromCookie();

    quizData.data.productsDetails = await getApiProductDetails(quizRawResults, quizData);
    registerUser(quizData.data.name, quizData.data.email, quizData.data.productsDetails[0]['ARCHETYPE']);
    quizData.data.icons = getIconsObj(quizData.data.productsDetails)
    quizData.data.nutrients = getNutrients(quizData);
    /* -- One Time Buy Products -- */
    quizData.data.oneTimeBuyMainProducts = await getProductsFromShopify(quizData.data.productsDetails, 'SINGLE_PURCHASE_SLUG');
    quizData.data.oneTimeBuySecondaryProducts =
        await getProductsFromShopify(quizData.data.productsDetails[0].CROSS_SELL_PRODUCTS, 'SINGLE_PURCHASE_SLUG');

    /*-- Subscription Products -- */
    quizData.data.subscriptionMainProducts = await getProductsFromShopify(quizData.data.productsDetails, 'SUBSCRIPTION_SLUG');
    quizData.data.subscriptionMainProducts.map(product => {
        product['compare_at_price'] = quizData.data.oneTimeBuyMainProducts
            .find(oneTimeBuyProduct => oneTimeBuyProduct.singlePurchaseSlug === product.singlePurchaseSlug).price;
    });

    quizData.data.subscriptionSecondaryProducts =
        await getProductsFromShopify(quizData.data.productsDetails[0].CROSS_SELL_PRODUCTS, 'SUBSCRIPTION_SLUG');
    quizData.data.subscriptionSecondaryProducts.map(product => {
        product['compare_at_price'] = quizData.data.oneTimeBuySecondaryProducts
            .find(oneTimeBuySecondaryProduct => oneTimeBuySecondaryProduct.singlePurchaseSlug === product.singlePurchaseSlug).price;
    });

    /* Same for one time but with archetypes not slug */
    quizData.data.oneTimeBuyMainProducts.map((product) => {
        let dbProductObj = quizData.data.productsDetails.find((dbProduct) => {
            return dbProduct.ARCHETYPE === product.sku
        })
        if (dbProductObj) {
            product = updateProductFromDB(product, dbProductObj)
        }
    })

    /** STEP 3 Products */
    // No discount

    quizData.data.singleUpsellProducts =
        await getProductsFromShopify(quizData.data.productsDetails[0].UPSELL_PRODUCTS, 'SINGLE_PURCHASE_SLUG');
    if (debug) {
        quizData.data.singleUpsellProducts[0].title += ' (single no offer)';
    }

    let subscribeBodyFuelProSlug = quizData.data.productsDetails[0].UPSELL_PRODUCTS[0].SUBSCRIPTION_SLUG;
    quizData.data.subscribeBodyFuelPro = await getProductsFromApiBySlugArray([subscribeBodyFuelProSlug]);
    quizData.data.subscribeBodyFuelPro = quizData.data.subscribeBodyFuelPro[0];
    quizData.data.subscribeBodyFuelPro = updateProductFromDB(quizData.data.subscribeBodyFuelPro,
        quizData.data.productsDetails[0].UPSELL_PRODUCTS[0])

    if (debug) {
        quizData.data.subscribeBodyFuelPro.title += ' (subs no offer)'
    }

    // With discount
    quizData.data.singleUpsellOfferProducts =
        await getProductsFromShopify(quizData.data.productsDetails[0].UPSELL_PRODUCTS, 'SINGLE_PURCHASE_OFFER_SLUG');
    if (debug) {
        quizData.data.singleUpsellOfferProducts[0].title += ' (single + offer)'
    }
    let subscribeBodyFuelProOfferSlug = quizData.data.productsDetails[0].UPSELL_PRODUCTS[0].SUBSCRIPTION_OFFER_SLUG;
    quizData.data.subscribeBodyFuelProOffer = await getProductsFromApiBySlugArray([subscribeBodyFuelProOfferSlug]);
    quizData.data.subscribeBodyFuelProOffer = quizData.data.subscribeBodyFuelProOffer[0];
    quizData.data.subscribeBodyFuelProOffer = updateProductFromDB(quizData.data.subscribeBodyFuelProOffer,
        quizData.data.productsDetails[0].UPSELL_PRODUCTS[0])

    if (debug) {
        quizData.data.subscribeBodyFuelProOffer.title += ' (subs + offer)'
    }
    /* Set compare_at_price from product  */
    // quizData.data.singleUpsellOfferProducts[0].compare_at_price = quizData.data.singleUpsellProducts[0].price;

    /* if US lets set ids of other products */
    if (quizData.data.usaGeo) {
        await setUSIds(quizData, quizRawResults);
    }

    console.log(quizData)

    const event = new MessageEvent('quiz-finished', quizData);
    const milliSecondsPassed = Date.now() - started;
    if (milliSecondsPassed < 3000) {
        setTimeout(() => {
                window.dispatchEvent(event)
            },
            3000 - milliSecondsPassed)
    } else {
        window.dispatchEvent(event)
    }
    clearTimeout(loaderId);
}

const setUSIds = async (quizData, quizRawResults) => {
    quizData.data.usProductsDetails = await getApiProductDetails(quizRawResults, quizData, 'US');
    quizData.data.subscriptionMainProducts.map(product => {
        let correspondingUSPProduct = quizData.data.usProductsDetails.find(serverProduct => serverProduct.ARCHETYPE === product.archetype);
        if (correspondingUSPProduct && correspondingUSPProduct.SUBSCRIPTION_VARIANTID) {
            product.variants[0]['id'] = correspondingUSPProduct.SUBSCRIPTION_VARIANTID;
        }
    })

    quizData.data.subscriptionSecondaryProducts.map(product => {
        let correspondingUSPProduct = quizData.data.usProductsDetails[0]['CROSS_SELL_PRODUCTS']
            .find(serverProduct => serverProduct.SUBSCRIPTION_SLUG.includes(product.handle));
        if (correspondingUSPProduct && correspondingUSPProduct.SUBSCRIPTION_VARIANTID) {
            product.variants[0]['id'] = correspondingUSPProduct.SUBSCRIPTION_VARIANTID;
        }
    })

    quizData.data.oneTimeBuyMainProducts.map(product => {
        let correspondingUSPProduct = quizData.data.usProductsDetails.find(serverProduct => serverProduct.ARCHETYPE === product.archetype);
        if (correspondingUSPProduct && correspondingUSPProduct.SUBSCRIPTION_VARIANTID) {
            product.variants[0]['id'] = correspondingUSPProduct.SUBSCRIPTION_VARIANTID;
        }
    })

    quizData.data.oneTimeBuySecondaryProducts.map(product => {
        let correspondingUSPProduct = quizData.data.usProductsDetails[0]['CROSS_SELL_PRODUCTS']
            .find(serverProduct => serverProduct.SUBSCRIPTION_SLUG.includes(product.handle));
        if (correspondingUSPProduct && correspondingUSPProduct.SUBSCRIPTION_VARIANTID) {
            product.variants[0]['id'] = correspondingUSPProduct.SUBSCRIPTION_VARIANTID;
        }
    })

    quizData.data.singleUpsellOfferProducts[1].variants[0]['id'] = quizData.data.usProductsDetails[0]['UPSELL_PRODUCTS'][1]['SINGLE_PURCHASE_OFFER_VARIANTID']
    quizData.data.singleUpsellProducts[1].variants[0]['id'] = quizData.data.usProductsDetails[0]['UPSELL_PRODUCTS'][1]['SINGLE_PURCHASE_VARIANTID']

}


function stringExistsAndNotEmpty(string) {
    return string && string !== "";
}

function updateProductFromDB(product, dbProductObj) {
    let title = stringExistsAndNotEmpty(dbProductObj.NAME) ? dbProductObj.NAME : product.title;
    title = stringExistsAndNotEmpty(dbProductObj.PRODUCT) ? dbProductObj.PRODUCT : title;
    title += stringExistsAndNotEmpty(dbProductObj.WEIGHT) ? ' - ' + dbProductObj.WEIGHT : "";
    product.title = title;
    product.servings = dbProductObj.SERVINGS ?? 0;
    product.servingsDesc = dbProductObj.SERVINGS_DESC ?? "";
    product.shortDesc = dbProductObj.DESC ?? "";
    product.archetype = dbProductObj.ARCHETYPE ?? "";
    product.servingsSize = dbProductObj.SERVING_SIZE ?? "";
    if (title.includes('NGX Personalised BodyFuel PRO')) {
        product.servingsSize = '35g';
    }
    product.minQty = dbProductObj.MIN_QTY;
    product.maxQty = dbProductObj.MAX_QTY;
    product.scoopId = dbProductObj.SCOOP_VARIANTID ?? null;
    product.singlePurchaseSlug = dbProductObj.SINGLE_PURCHASE_SLUG ?? '';
    product.container = dbProductObj.CONTAINER ?? '';

    product.getProductShortDescription = function (price = null) {

        if (!price) {
            price = this.price;
        }

        if (this.title.includes('DNA')) {
            return this.shortDesc;
        }
        let productShortDescription = this.servings + 'x ' + this.servingsSize + ' ' + this.servingsDesc.toLowerCase() + ' | ';
        productShortDescription += getPriceWithCurrency(Math.round((price / this.servings)) / 100);
        productShortDescription += ' per ' + product.servingsDesc.toLowerCase().slice(0, -1);

        return productShortDescription;
    }
    product.getUserFriendlyCartPrice = function (price = null) {
        if (!price) {
            price = this.price;
        }
        let userFriendlyPrice = getPriceWithCurrency(price / 100);
        if (this.container !== '') {
            userFriendlyPrice += ' per ' + this.container;
        }
        return userFriendlyPrice;
    }

    return product;
}

function getPriceWithCurrency(price) {
    price = parseFloat((Math.round(price * 100) / 100).toFixed(2))

    if (this.isCurrencyWithComma()) {
        price = price.toLocaleString("en-AT", {minimumFractionDigits: 2});
    }
    price = price.toLocaleString("en-GB", {minimumFractionDigits: 2});


    if (isSpecialCurrencySign(getCurrencySignFromCookie())) {
        return getCurrencySignFromCookie() + price;
    } else {
        return '' + price + ' ' + getCurrencySignFromCookie();
    }
}

function normalisePrice(price) {
    return parseFloat((Math.round((price * 100) / 100)).toFixed(2))
}

function getNutritionLevel(quizRawResults) {
    let score = 0;
    for (questionId in nutritionScoreReferencer) {
        questionObj = quizRawResults.getQuestionDataById(questionId);
        // console.log('questionId', questionId, typeof questionObj, questionObj)
        if (!questionObj) continue;
        let currentAnswerScore = null;
        if (nutritionScoreReferencer[questionId].universalScore) {
            currentAnswerScore += getAnswersByQuestionId(questionId, quizRawResults).length;
        } else {
            let answers = getAnswersByQuestionId(questionId, quizRawResults);
            if (answers.length) {
                currentAnswerScore = answers.reduce((previousValue, answerId) => {
                    let answerPosition = getAnswerPosition(questionId, quizRawResults, answerId)
                    return previousValue + nutritionScoreReferencer[questionId].reference[answerPosition]
                }, 0)
            }
            if ((!answers.length) && nutritionScoreReferencer[questionId].emptyAnswerScore) {
                currentAnswerScore += nutritionScoreReferencer[questionId].emptyAnswerScore;
            }
            // console.log('currentAnswerScore' ,currentAnswerScore, score)
            score += !isNaN(currentAnswerScore) ? currentAnswerScore : 0;
        }
    }
    return 14 - (score / 27);
}

function getAnswersByQuestionId(questionId, quizRawResults) {
    return quizRawResults.getQuestionDataById(questionId).attributes.values;
}

function getAnswerPosition(questionId, quizRawResults, answerId) {
    let answer = quizRawResults.getQuestionDataById(questionId).attributes.choices.data.find(choice => choice.id === answerId)
    return answer ? answer.attributes.position : -1;
}

function getRawAnswer(questionId, quizRawResults) {
    let question = quizRawResults.getQuestionDataById(questionId);
    return question.attributes.values[0];
}

function getProducts(quizRawResults) {
    return Array.from(quizRawResults.response.attributes.recommended_products)
}

function getSelectSingeAnswerText(questionId, quizRawResults) {
    let question = quizRawResults.getQuestionDataById(questionId);
    let answerId = question.attributes.values[0];
    if (questionId === "GQin0RG") {
        switch (question.attributes.values[0]) {
            case 'xoheynw':
                return 'Male';
            case 'zWhJ739':
                return 'Female';
        }
    }
    let answer = question.attributes.choices.data.find(choice => choice.id === answerId)
    return answer ? answer.attributes.label : "";
}

function getMultipleSelectAnswersAsText(questionId, quizRawResults) {
    let question = quizRawResults.getQuestionDataById(questionId);
    let answers = question.attributes.values;
    return answers.map((answerId) => question.attributes.choices.data.find(choice => choice.id === answerId).attributes.label)
}

function getAge(questionId, quizRawResults) {
    let question = quizRawResults.getQuestionDataById(questionId);
    let today = new Date();
    let birthDate = new Date(question.attributes.values[0]);
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return (Math.ceil((age + 1) / 10) * 10) - 10;
}

async function getApiProductDetails(quizRawResults, quizData, iso2 = null) {
    const recommendedProducts = getProducts(quizRawResults);

    const archetype = recommendedProducts.find(product => product.name.includes('BodyFuel'));
    const powerpack = recommendedProducts.find(product => product.name.includes('PowerPack'));
    const boosterpack = recommendedProducts.find(product => product.name.includes('Booster'));
    const fatsOrCarbsProduct = recommendedProducts.find(product => product.name.includes('Quiz Fats or Carbs'));
    let data = {
        archetype: archetype ? archetype.sku : "",
        powerpack: powerpack ? powerpack.sku : "",
        boosterpack: boosterpack ? boosterpack.sku : "",
        gender: quizData.data.gender.toLowerCase(),
        goal: quizData.data.fitnessGoals.slice(0, -1).join(', ') + quizData.data.fitnessGoals.slice(-1),
        fatsOrCarbs: fatsOrCarbsProduct ? fatsOrCarbsProduct.sku : "",
        currentWeight: quizData.data.weight,
        targetWeight: quizData.data.targetWeight,
        iso2: iso2 ?? 'UK'
        // iso2 : 'UK'
    }

    return fetch('https://ngx-nutrition.com/quiz-api/?' + new URLSearchParams(data))
        .then(response => response.json())
        .then(async data => {
            return JSON.parse(data.data).PRODUCT
        })
}

/*function getDietaryNeeds(quizRawResults) {
    const lactoseAnswerPosition = getAnswerPosition('Wki0LE6', quizRawResults,
        getRawAnswer('Wki0LE6', quizRawResults));
    const glutenAnswerPosition = getAnswerPosition('a2iLV86', quizRawResults,
        getRawAnswer('a2iLV86', quizRawResults));
    const diet = getSelectSingeAnswerText('jxiVBMj', quizRawResults);
    let dietaryNeeds = (lactoseAnswerPosition === 1 ? 'Lactose Free, ' : '');
    dietaryNeeds += (glutenAnswerPosition === 1 ? 'Gluten Free, ' : '');
    dietaryNeeds += diet !== 'None of the above';
    return dietaryNeeds
}*/

/*function howToTake(questionId, quizRawResults) {
    const answerPosition = getAnswerPosition('a2iLV86', quizRawResults,
        getRawAnswer('a2iLV86', quizRawResults));
    /!** if answer position is 2,3,4 return value else return hardcoded *!/
    return [2, 3, 4].includes(answerPosition) ? getSelectSingeAnswerText('a2iLV86', quizRawResults) : 'Replace food';
    return 'Replace food';
}*/

function getNutrients(quizData) {
    let nutrients = [];
    quizData.data.productsDetails.map((product) => product.BOOSTED_MICRO_NUTRIENTS ? product.BOOSTED_MICRO_NUTRIENTS.map((nutrient) => {
        if (!nutrients.find((savedNutrient) => savedNutrient.NAME === nutrient.NAME)) {
            nutrients.push(nutrient)
        }
    }) : '')
    return nutrients;
}
async function getProductsFromApiBySlugArray(slugArr) {
    let promises = slugArr.map(async slug => {
        return fetch(window.Shopify.routes.root + 'products/' + slug + '.js')
            .then(response => response.json())
            .then(data => {
                return data
            })
    })
    return await Promise.all(promises);
}

async function getProductsFromShopify(dbProductsArray, slugFieldName) {
    let productsSlugs = dbProductsArray.map(item => item[slugFieldName]).filter(item => item !== "").filter((item) => item.length > 0);
    let products = await getProductsFromApiBySlugArray(productsSlugs);

    products.map((product) => {
        let dbProductObj = dbProductsArray.find((dbProduct) => {
            return dbProduct[slugFieldName] === product.handle
        })
        if (dbProductObj) {
            product = updateProductFromDB(product, dbProductObj)
        }
    })
    return products;
}

function appTimerComponent() {
    const timerInProgress = localStorage.getItem('timerInProgress');
    // const timerInProgress = false;
    return {
        countdown: timerInProgress ? timerInProgress : 1800,
        // countdown: 36,
        minutes: 30,
        seconds: '00',
        startTimer() {
            let refreshIntervalId = window.setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown = this.countdown - 1;
                    this.minutes = Math.floor(this.countdown / 60);
                    this.seconds = this.countdown - (this.minutes * 60)
                    this.seconds = this.seconds < 10 ? '0' + this.seconds : this.seconds;
                    localStorage.setItem('timerInProgress', this.countdown);
                }
                if (this.countdown == 0) {
                    const event = new MessageEvent('discount-time-passed');
                    window.dispatchEvent(event);
                    console.log('discount-time-passed dispatched')
                    clearInterval(refreshIntervalId);
                }
            }, 1000)
        }
    }
}

function getOnlyFirstName(name) {
    return name && name.length ? name.split(' ')[0] : "";
}

function registerUser(firstName, email, archetype) {
    fetch('https://ngx-nutrition.com/quiz-api/update-user-archetype.php', {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        mode: 'no-cors',
        body: new URLSearchParams({
            'first_name': firstName,
            email,
            archetype
        })
    })
}

function closeOpenedIngredients(id) {
    document.getElementById(id).classList.toggle('ingredient-opened')
    const ingredients = Array.from(document.getElementsByClassName('quiz-left-part-ngx-bodyfuel-ingredients-label'));
    ingredients.forEach(
        ingredientEl => {
            if (ingredientEl.getAttribute('for') !== id) {
                let matchingCheckboxEl = document.getElementById(ingredientEl.getAttribute('for'))
                matchingCheckboxEl.checked = false;
            }
        }
    )
}

function getProductsStepThree(results, discountAvailable, subscribeTypePurchase) {
    console.log('get products', results, 'discountAvailable', discountAvailable, 'subscribeTypePurchase', subscribeTypePurchase)
    let products = [...results.singleUpsellProducts];
    if (discountAvailable) {
        console.log('discountAvailable')
        products = [...results.singleUpsellOfferProducts];
    }
    if (subscribeTypePurchase) {
        console.log('subscribeTypePurchase')
        products[0] = {...results.subscribeBodyFuelPro};
        if (discountAvailable) {
            console.log('and discountAvailable')
            products[0] = {...results.subscribeBodyFuelProOffer};
        }
    }
    products.forEach((product) => product.variants[0].id = parseInt(product.variants[0].id))
    console.log('getProductsStepThree products', products)
    return products.sort()
}

function getSubscription() {
    return localStorage.getItem('cart-subscription')
        && (localStorage.getItem('cart-subscription') !== 'false')
        && (localStorage.getItem('cart-subscription') !== false);
}
